"use client";

/**
 * CollabV3ShareButton 컴포넌트
 * @description 헤더 오른쪽 공유 — 공용 `ShareButton` 에 계측만 얹는다(2.0 상세의 `ShareButton` 과 같은
 *   `Collab Shared`, `placement: "header"`). 링크를 퍼뜨리는 것은 보기 전용 페이지에서도 할 수 있는 일이다.
 * @example <CollabV3ShareButton title={detail.title} subject={subject} />
 */
import { memo, useCallback } from "react";

import type { CollabV3ShareButtonProps } from "./CollabV3Detail.types";

import { trackCollabV3Shared } from "../../analytics";
import type { ShareOutcome } from "@/shared/lib/share";
import { ShareButton } from "@/shared/ui";

const CollabV3ShareButton = memo<CollabV3ShareButtonProps>(
  ({ title, subject }) => {
    const onShared = useCallback(
      (outcome: ShareOutcome) => trackCollabV3Shared(subject, outcome),
      [subject],
    );
    return <ShareButton title={title} onShared={onShared} />;
  },
);

CollabV3ShareButton.displayName = "CollabV3ShareButton";

export default CollabV3ShareButton;
